import styled, { css } from 'styled-components';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { ReactComponent as WebIcon } from 'icons/website.svg';
import Link from 'components/Link';

export const Container = styled.div`
  background-color: ${({ theme }) =>
    theme.configs.trackingDetailsBox.headerAndFooter.bgColor};
  color: ${({ theme }) => theme.configs.mainBox.fontColor};
  padding: 8px 12px;
  display: flex;
  align-items: center;
  height: 56px;
  margin-top: auto;
  background-image: ${({ theme }) => {
    const {
      isGradient,
      gradientRatio,
      firstBgColor,
      firstBgColorDensity,
      secondBgColor,
      secondBgColorDensity,
    } = theme.configs.trackingDetailsBox.headerAndFooter;
    if (isGradient) {
      return `linear-gradient(${gradientRatio}deg, ${firstBgColor} ${firstBgColorDensity}%, ${secondBgColor} ${secondBgColorDensity}%)`;
    }
    return 'none';
  }};
`;

export const Logo = styled.div`
  height: 40px;
  width: 40px;
`;

export const CarrierInfo = styled.div`
  display: flex;
  margin-right: auto;
  align-items: center;
`;

const carrierLinkCss = css`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.configs.mainBox.fontColor};
  text-decoration-color: ${({ theme }) => theme.configs.mainBox.fontColor};

  &:nth-child(n + 2) {
    &::before {
      content: ',';
      margin-right: 4px;
    }
  }
`;

export const CarrierLink = styled(Link)`
  ${carrierLinkCss}
`;

// Desktop-only: non-clickable phone number that anchors the tooltip
export const CarrierPhoneText = styled.span`
  ${carrierLinkCss}
`;

export const CarrierName = styled.div`
  color: ${({ theme }) => theme.configs.mainBox.fontColor};
  margin-left: 8px;
  font-weight: 700;
  font-size: ${({ theme }) => theme.configs.fonts.fontSize.additionalDetails}px;
`;

export const Menu = styled.div`
  display: flex;
`;

const optionCss = css`
  width: 36px;
  height: 36px;
  position: relative;
  border-radius: ${({ theme }) =>
    theme.configs.trackingDetailsBox.borderRadius === 'round' ? '18px' : '8px'};
  margin: 0 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: ${({ theme }) =>
    theme.configs.trackingDetailsBox.carrierIconBgColor};
  color: ${({ theme }) =>
    theme.configs.trackingDetailsBox.carrierIconFontColor} !important;
  border: none;

  // [customer-site-conflict-issue][css]
  & svg {
    width: initial;
    height: auto;
  }
`;

export const Option = styled(Link)`
  ${optionCss}
`;

// Desktop-only: button that anchors the phone tooltip instead of a tel: link
export const PhoneIconButton = styled.button.attrs({ type: 'button' })`
  ${optionCss}
`;

export const HyperlinkIcon = styled(WebIcon)`
  color: ${({ theme }) => theme.configs.mainBox.fontColor};
  margin-left: 4px;
  width: 16px;
  height: 16px;
`;

interface CarrierTooltipProps {
  textColor?: string;
  backgroundColor?: string;
}

export const CarrierTooltip = styled(ReactTooltip).attrs<CarrierTooltipProps>(
  ({ textColor, backgroundColor }) => ({
    style: {
      backgroundColor: backgroundColor || undefined,
      color: textColor || undefined,
      padding: '8px',
    },
  }),
)<CarrierTooltipProps>`
  filter: drop-shadow(
    0 0 2px ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor}
  ) !important;

  /* Disable fade animation for instant show/hide */
  --rt-transition-show-delay: 0s;
  --rt-transition-closing-delay: 0s;

  /* Force color on all child elements */
  * {
    color: inherit !important;
  }
`;

export const TooltipContent = styled.button`
  font-size: 12px;
  background: none;
  border: none;
  padding: 0;
  width: fit-content;
  font-family: inherit;
  cursor: pointer;
`;

export const DotsIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;
